import { Avatar, Button, Dialog, Image, ImageUploader, ImageViewer, NavBar, TextArea } from "antd-mobile"
import { MessageOutline, PictureOutline, } from 'antd-mobile-icons';
import React, { useEffect, useRef, useState } from "react"
import { AlertContent, FullURL, ToastContent, ToDate1 } from "../factory/FactoryUtil";
import { chatSend, chatData, chatListenReply } from "../../NetworkFactory";
import { NavbarFeedbackIcon } from "../icons";
import { avatarData } from "../../NetworkFactory";
import { CellStateView } from '../factory/CellViews';

const LogoView = ({children, bgColor = '#eee'}) => {
    return (
        <div style={{
            minWidth : '38px',
            height : '38px',
            background : bgColor,
            borderRadius : '100px',
            overflow : 'hidden'
        }}>{children}</div>
    )
}

const MessageView = ({isRight = false, item = {}, onClickImage = ()=>{}}) => {
    const bgColor = isRight ? '#ABEF7A' : '#B2DDFA'
    return (
        <div style={{flex : '1', display : 'flex'}}>
            {
                isRight ? <div style={{flex : '1'}}></div> : <></>
            }
            {
                item.type === 0 ? (
                    <div style={{
                        background : bgColor, 
                        display : 'inline-block',
                        borderRadius : '20px',
                        fontSize : '16px',
                        padding : '8px 20px',
                        color : '#000',
                        wordBreak: 'break-word',
                        maxWidth : '70%'
                    }}>{item.message}</div>
                ) : (
                    <Image src={FullURL(item.message)} width={120} height={120} 
                    fit='cover' 
                    style={{borderRadius : '15px', overflow : 'hidden'}} onClick={onClickImage}/>
                )
            }
        </div>
    )
}

const ItemView = ({isLeft = true, item = {}, onClickImage = ()=>{}}) => {
    if(isLeft) {
        return (
            <div style={{display : 'flex'}}>
                <LogoView bgColor='#B2DDFA'>
                    <div style={{margin : '6px'}}><NavbarFeedbackIcon/></div>
                </LogoView>
                <div style={{width : '8px'}}></div>
                <MessageView item={item} onClickImage={onClickImage}/> 
            </div>
        )
    }
    return (
        <div style={{display : 'flex'}}>
            <MessageView isRight={true} item={item} onClickImage={onClickImage}/>
            <div style={{width : '8px'}}></div>
            <Avatar src={avatarData()}  style={{'--size' : '38px', '--border-radius' : '30px'}}/>
        </div>
    )
}

let tempTimer = null
let initLoadingDone = false
let lastDate = '0'

const ChatController = ({goback}) => {
    const [message, setMessage] = useState('')
    const [data, setData] = useState([])
    const [newdata, setNewData] = useState([])
    const [sending, setSending] = useState(false)
    const messagesEndRef = useRef(null);
    const input = useRef(null)
    const [visible, setVisible] = useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [stateCode, setStateCode] = useState(3);

    const sendMessage = () => {
        if(message.trim().length === 0) {
            AlertContent('Cannot send blank message')
        } else if(message.length <1 || message.length > 250) {
            AlertContent('Please enter message length limit [1-250]')
        } else {
            setSending(true)
            chatSend({message, type : 0}).then((res) => {
                const item = res.data?.data
                if(item) {
                    setData([...data, item])
                }
                setMessage('')
            }).catch(() => {
                ToastContent('Send message fail')
            }).finally(() => {
                setSending(false)
            })
        }
    }
    // # 打开图片
    const openPhoto = () => {
        const nativeInput = input.current?.nativeElement
        if (nativeInput) {
            nativeInput.click()
        }
    };
    // # 处理选择图片
    const handerPhoto = (file) => {
        return new Promise(() => {
            const reader = new FileReader();
            reader.onload = (e) => {
                showSendImageAlert(e.target.result)
            };
            reader.readAsDataURL(file);
        });
    }
    // # 提示是否发送图
    const showSendImageAlert = (base64Img) => {
        Dialog.confirm(
            {
                title : 'Confirm send picture',
                content : <div style={{textAlign : 'center'}}><Image width='100%' height={120} fit='contain' src={base64Img} style={{margin : 'auto'}}/></div>,
                confirmText : 'Send',
                cancelText : <div style={{color : '#999'}}>Cancel</div>,
                onConfirm : () => {
                    sendImg(base64Img)
                }
            }
        )
    }
    // # 发送图片
    const sendImg = (base64Img) => {
        chatSend({message : base64Img, type : 1}).then((res) => {
            const item = res.data?.data
            if(item) {
                setData([...data, item])
            }
        })
    }
    // # 请求聊天数据
    const requestData = () => {
        chatData().then(res => {
            const data = res.data.data ?? []
            updateLastDate(data)
            setData(data)
        }).finally(() => {
            initLoadingDone = true
            setStateCode(0)
        })
    }

    // # 滚动到底部
    const scrollToBottom = () => {
        const container = messagesEndRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    };

    // // # 查找最后回复时间
    const updateLastDate = (data = []) => {
        for(let i = data.length -1; i>=0;i--) {
            const item = data[i]
            if(item.direction !== '-1') {
                lastDate = item.creationDate
                break
            }
        }
    }

    // # 请求最新消息
    const requestNewMessage = () => {
        chatListenReply({'last_date' : lastDate}).then(res => {
            const newdata = res.data?.data ?? []
            if(newdata.length > 0) {
                const temp = []
                for(let i = newdata.length -1; i>=0;i--) {
                    temp.push(newdata[i])
                }
                updateLastDate(newdata)
                setNewData(temp)
            }
        })
    }

    // # 监听新消息
    const startListenMessage = () => {
        tempTimer = setInterval(() => {
            if(initLoadingDone) {
                requestNewMessage()
            }
        }, 6 * 1000);
    }

    // # 监听输入消息变化
    useEffect(() => {
        scrollToBottom();
    }, [data]);

    useEffect(() => {
        setData(d=>[...d, ...newdata])
    }, [newdata]);
    
    // # 初始化请求数据
    useEffect(() => {
        requestData()
        startListenMessage()
        return (() => {
            if(tempTimer) {
                clearInterval(tempTimer)
                tempTimer = null
            }
        })
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{
            position : 'absolute',
            left: 0,
            top : 0,
            right : 0,
            bottom : 0,
            display : 'flex',
            flexDirection : 'column'
        }}>
            <NavBar onBack = {goback} >Customer service</NavBar>
            <CellStateView stateType={stateCode}/> 
            <ImageViewer visible={visible} image={previewImage} onClose={()=>{setVisible(false)}}/>
            {
                stateCode === 0 && data.length === 0 ? (<div style={{textAlign : 'center', fontSize : '16px', color : '#666', marginTop : '50px', padding : '0 15%', boxSizing : 'border-box'}}>
                    <MessageOutline fontSize={50} color="#3489EC"/>
                    <div style={{marginTop : '10px'}}>Welcome send message, here if you have any questions</div>
                </div>) : <></>
            }
            <ImageUploader
                ref={input}
                accept = 'image/jpeg,image/jpg,image/png'
                beforeUpload={handerPhoto}
                maxCount={1} 
                columns={0}
                onPreview={false}
                style={{display : 'none'}}
            />
            <div ref={messagesEndRef} style={{
                flex : '1', 
                padding : '0 15px', 
                paddingTop : '0', 
                boxSizing: 'border-box', 
                overflow : 'auto'}}>
               {
                data.map((item, key) => (
                    <div key={key} style={{marginBottom : '30px'}}>
                        <div style={{
                            textAlign : 'center', 
                            margin: '8px 0',
                            color : '#999',
                            fontSize : '11px'
                        }}>{ToDate1(item.creationDate)}</div>
                        <ItemView isLeft={item.direction !== '-1'} item={item} onClickImage={()=>{
                            setVisible(true);
                            setPreviewImage(item.message)
                        }}/>
                    </div>
                ))
               }
            </div>
            <div style={{
                padding : '8px 15px',
                boxSizing : 'border-box',
                display : 'flex',
                alignItems : 'flex-end'
            }}>
                <TextArea
                    disabled={sending}
                    value={message}
                    onChange={(val)=>{setMessage(val)}}
                    placeholder="Enter message" 
                    maxLength={255} 
                    rows={1} 
                    autoSize={{minRows : 1, maxRows : 4}} 
                    style={{
                        '--font-size' : '16px',
                        padding : '5px 10px', 
                        boxSizing: 'border-box',
                        border: '1.5px solid #eee',
                        borderRadius : '20px',
                        flex : '1',
                }}/>
                <Button loading={sending} onClick={sendMessage} shape='rounded' color="primary" style={{padding : '6px 18px', marginLeft : '6px'}}>Send</Button>
                <Button disabled={sending} onClick={openPhoto} shape='rounded' style={{padding : '6px 10px', marginLeft : '6px'}}> <PictureOutline /></Button>
            </div>
        </div>
    )
}

export default React.memo(ChatController)